var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileNumeric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9943 7.01428V6.81428C19.9943 5.13412 19.9943 4.29405 19.6673 3.65231C19.3797 3.08782 18.9208 2.62888 18.3563 2.34126C17.7145 2.01428 16.8745 2.01428 15.1943 2.01428H8.79429C7.11414 2.01428 6.27406 2.01428 5.63232 2.34126C5.06784 2.62888 4.60889 3.08782 4.32127 3.65231C3.99429 4.29405 3.99429 5.13412 3.99429 6.81428V17.2143C3.99429 18.8944 3.99429 19.7345 4.32127 20.3763C4.60889 20.9407 5.06784 21.3997 5.63232 21.6873C6.27406 22.0143 7.11414 22.0143 8.79429 22.0143H12.4943M7.5 11.2999L9.5 10.3001V18.3005M19 18.1005L13.5 18.1C16 15.9333 19.2216 13.1324 18 11.3C16.7784 9.50998 13.5 10.3 13.5 12.3",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNumeric);
export default __webpack_public_path__ + "static/media/file-numeric.401bb45479ac8f485b083769e80bf4e3.svg";
export { ForwardRef as ReactComponent };